// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"a10a3f92e9--thumbnail--2wYQT","icon":"a10a3f92e9--icon--1e41C","text":"a10a3f92e9--text--2-RgZ"};